import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-ai-conversation-box',
  templateUrl: './ai-conversation.component.html',
  styleUrls: ['./ai-conversation.component.scss'],
})
export class AIConversationComponent implements OnInit {
  @Input() conversation: {
    dateCreated: string;
    status: string;
    countMetadata: any;
    sessionId: string;
    conversationSubject: string;
  };

  @Input() isSelected: any;

  @Output() viewConversation: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  viewMessages(item: any) {
    // console.log(item, 'here');
    this.viewConversation.emit(item);
    console.log(this.isSelected, item.sessionId);
  }
}
